import { takeLatest, put, select, call } from "redux-saga/effects";

import { httpService } from "@app/services";
import { bootstrapApp, markAppAsReady } from "./slice";
import { selectIsAuthenticated, selectLoginDataState } from "../common";
import { logout } from "../auth";

function* bootstrapSaga(): any {
  try {
    const isAuthenticated = yield select(selectIsAuthenticated);
    if (isAuthenticated) {
      yield call(prepareUserSessionSaga);
    } else {
      // Force logout
      yield put(logout());
    }
  } catch (err) {
    console.log("Error - bootstrapSaga", err);
  } finally {
    yield put(markAppAsReady());
  }
}

function* prepareUserSessionSaga(): any {
  const data = yield select(selectLoginDataState);
  const token = data?.token;
  httpService.setToken(token);
}

function* bootstrapSagas() {
  yield takeLatest(bootstrapApp, bootstrapSaga);
}

export { bootstrapSagas, prepareUserSessionSaga };
